module.exports = __webpack_public_path__ + "img/any_soft_compute.c907a94d.png";